import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71b55e20"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-bloc-form grid grid-cols-3 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "EDITER UN MOYEN D'EXPEDITION"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "flex justify-content-center"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-bloc-form grid grid-cols-3 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Politique particulière*")
], -1))
const _hoisted_5 = { class: "not-valid mb-2" }
const _hoisted_6 = { class: "formkit-message text-red-500 text-xs" }
const _hoisted_7 = { class: "not-valid mb-2" }
const _hoisted_8 = { class: "formkit-message text-red-500 text-xs" }
const _hoisted_9 = { class: "item-bloc-form" }
const _hoisted_10 = { class: "grid grid-cols-2" }
const _hoisted_11 = { class: "pr-2 supplier-item-form" }
const _hoisted_12 = { class: "pr-2 supplier-item-form" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "supplier-item-form devise" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "formkit-label font-bold text-sm" }, " € ")
], -1))
const _hoisted_14 = { class: "not-valid mb-2" }
const _hoisted_15 = { class: "formkit-message text-red-500 text-xs" }
const _hoisted_16 = { class: "item-bloc-form" }
const _hoisted_17 = { class: "grid grid-cols-2" }
const _hoisted_18 = { class: "pr-2 supplier-item-form" }
const _hoisted_19 = { class: "pr-2 supplier-item-form" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "supplier-item-form devise" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "formkit-label font-bold text-sm" }, " € ")
], -1))
const _hoisted_21 = { class: "not-valid mb-2" }
const _hoisted_22 = { class: "formkit-message text-red-500 text-xs" }
const _hoisted_23 = { class: "item-bloc-form" }
const _hoisted_24 = { class: "grid grid-cols-2" }
const _hoisted_25 = { class: "pr-2 supplier-item-form" }
const _hoisted_26 = { class: "pr-2 supplier-item-form" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "supplier-item-form devise" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "formkit-label font-bold text-sm" }, " € par produit ")
], -1))

import {ref, onMounted} from 'vue'
import ApiService from "@/_services/api.service";
import Swal from "@/_helpers/swal";
import {
  getIndexErrorStartingFrom,
  getShippingMethod,
  IShippingMethod,
  updateShippingMethod
} from "@/_services/shippingMethod/shippingMethod";
import {useRoute} from "vue-router";
import router from "@/router";
import ProgressSpinner from 'primevue/progressspinner';

export default /*#__PURE__*/_defineComponent({
  __name: 'EditShippingMethod',
  setup(__props) {

const supplierUuid = ref<string>("");
const shippingMethodUuid = ref<string>("");
const messageErrorParticularPolicyModel = ref();
const messageErrorStartingFromByPrice = ref();
const messageErrorStartingFromByQuantity = ref();
const messageErrorStartingFromByProduct = ref();
const shippingRulesByType = ref({});

const transportors = ref([]);
const shippingRuleByPriceStatus = ref<boolean>();
const shippingRuleByQuantityStatus = ref<boolean>();
const shippingRuleByProductStatus = ref<boolean>();
const shippingMethod = ref<IShippingMethod>({
  name: "",
  deliveryTime: "",
  shippingRules: [],
  supplier: "",
  transporter: "",
  shippingRuleByPriceStatus: false,
  shippingRuleByQuantityStatus: false,
  shippingRuleByProductStatus: false
} as unknown as IShippingMethod);
const route = useRoute();
const isLoading = ref<boolean>(true);

onMounted(async () => {
  shippingMethodUuid.value = route.params.uuid as string;
  await getTransportors();
  await updateShippingMethodFromApi(shippingMethodUuid.value);
  hideSpinner();
});

const getTransportors = async () => {
  await ApiService.get("all-transporters?isActive=true")
    .then(({ data }) => {
      data.data.forEach((item) => {
        transportors.value.push({ label: item.name, value: item.uuid });
      });
    })
    .catch(() => {
      return false;
    });
};
const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}
const validateShippingRuleStatus = (data) => {
  return (
    data.shippingRuleByPriceStatus ||
    data.shippingRuleByQuantityStatus ||
    data.shippingRuleByProductStatus
  );
};

const checkErrorStartingFrom = (data) => {
  let error = false;
  if (data.shipping_rules_by_price) {
    if (parseInt(data.shipping_rules_by_price[0].startingFrom) !== 0) {
      messageErrorStartingFromByPrice.value = "La première règle est obligatoire, elle doit impérativement commencer à 0";
      error = true;
    }
  }
  if (data.shipping_rules_by_quantity) {
    if (parseInt(data.shipping_rules_by_quantity[0].startingFrom) !== 1) {
      messageErrorStartingFromByQuantity.value = "La première règle est obligatoire, elle doit impérativement commencer à 1";
      error = true;
    }
  }
  if (data.shipping_rules_by_product) {
    if (parseInt(data.shipping_rules_by_product[0].startingFrom) !== 1) {
      messageErrorStartingFromByProduct.value = "La première règle est obligatoire, elle doit impérativement commencer à 1";
      error = true;
    }
  }
  return error;
}

const initFormErrorMessage = () => {
  messageErrorStartingFromByPrice.value = '';
  messageErrorStartingFromByQuantity.value = '';
  messageErrorStartingFromByProduct.value = '';
  messageErrorParticularPolicyModel.value = '';
}

const submitHandler = async (data, formNode) => {
  try {
    formNode.clearErrors();
    initFormErrorMessage();
    if (!validateShippingRuleStatus(data)) {
      messageErrorParticularPolicyModel.value = 'Vous devez sélectionner au moins un modèle de politique particulières.'
      return false;
    }

    if (checkErrorStartingFrom(data)) {
      return false;
    }

    if (data.shipping_rules_by_price) {
      let index = getIndexErrorStartingFrom(data.shipping_rules_by_price);
      if (index > 0) {
        const key = `shipping_rules_by_price.${index}.startingFrom`;
        formNode.setErrors(
          null,
          {
            [key]: ['La valeur ne peut pas être inférieur ou égale à la précédente']
          }
        );
        return false;
      }
    }

    if (data.shipping_rules_by_quantity) {
      let index = getIndexErrorStartingFrom(data.shipping_rules_by_quantity);
      if (index > 0) {
        const key = `shipping_rules_by_quantity.${index}.startingFrom`;
        formNode.setErrors(
          null,
          {
            [key]: ['La valeur ne peut pas être inférieur ou égale à la précédente']
          }
        );
        return false;
      }
    }

    if (data.shipping_rules_by_product) {
      let index = getIndexErrorStartingFrom(data.shipping_rules_by_product);
      if (index > 0) {
        const key = `shipping_rules_by_product.${index}.startingFrom`;
        formNode.setErrors(
          null,
          {
            [key]: ['La valeur ne peut pas être inférieur ou égale à la précédente']
          }
        );
        return false;
      }
    }

    data.supplierUuid = supplierUuid.value;
    await Swal
      .confirm("Êtes vous sûr de vouloir éditer ce moyen d’expédition", "Annuler", "Oui, éditer")
      .then(async (results) => {
        if (results.isConfirmed) {
          const res = await updateShippingMethod(shippingMethodUuid.value, data);
          if (res) {
            Swal.info("Vous venez de modifier un moyen d’expédition").then(() => {
              router.push({ name: 'supplierDetail', params: { uuid: supplierUuid.value, ariaSelected: 1 } })
            })
          } else {
            Swal.error("La modification du moyen d’expédition a échoué veuillez réessayer.");
          }
        }
      });
  } catch (err: any) {
    Swal.error(err.errors[0]);
  }
}

const updateShippingMethodFromApi = async (uuid: string) => {
  await getShippingMethod(uuid).then((res) => {
    shippingMethod.value = res;
    supplierUuid.value = res.supplier.uuid;
    groupShippingRulesByType(shippingMethod.value.shippingRules);
    shippingRuleByPriceStatus.value = shippingMethod.value.shippingRuleByPriceStatus;
    shippingRuleByQuantityStatus.value = shippingMethod.value.shippingRuleByQuantityStatus;
    shippingRuleByProductStatus.value = shippingMethod.value.shippingRuleByProductStatus;
  });
};

const groupShippingRulesByType = (data) => {
  shippingRulesByType.value = [];
  data.forEach(item => {
    const itemType = item.type;
    if (!shippingRulesByType.value[itemType]) {
      shippingRulesByType.value[itemType] = [];
    }
    shippingRulesByType.value[itemType].push(item);
  });

  return shippingRulesByType;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ProgressSpinner), {
            style: {"width":"50px","height":"50px"},
            strokeWidth: "8",
            fill: "var(--surface-ground)",
            animationDuration: ".5s",
            "aria-label": "Custom ProgressSpinner"
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FormKit, {
      type: "form",
      id: "edit-supplier",
      "form-class": _ctx.submitted ? 'hide' : 'show',
      "submit-label": "Enregistrer",
      onSubmit: submitHandler,
      action: true,
      "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          type: "select",
          label: "Transporteur",
          name: "transportor",
          validation: "required",
          "validation-visibility": "dirty",
          modelValue: shippingMethod.value.transporter.uuid,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shippingMethod.value.transporter.uuid) = $event)),
          "validation-messages": {required: 'Il faut choisir un transporteur dans la liste déroulante.',}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transportors.value, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.value,
                value: item.value
              }, _toDisplayString(item.label), 9, _hoisted_3))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "validation-messages"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "name",
          label: "Nom du moyen d’expédition",
          validation: "required|length:1,50|contains_alpha",
          "validation-visibility": "dirty",
          "validation-messages": {required: 'Nom du moyen d’expédition obligatoire.',
           length: 'Vous pouvez saisir maximum 50 caractères',
           contains_alpha: 'Les valeurs numériques seules ne sont pas acceptées'},
          modelValue: shippingMethod.value.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shippingMethod.value.name) = $event))
        }, null, 8, ["validation-messages", "modelValue"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "deliveryTime",
          modelValue: shippingMethod.value.deliveryTime,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shippingMethod.value.deliveryTime) = $event)),
          label: "Délai de livraison",
          validation: "required|length:1,25",
          "validation-visibility": "dirty",
          "validation-messages": {required: 'Vous devez entrer un délai de livraison', length: 'Vous pouvez saisir maximum 25 caractères'}
        }, null, 8, ["modelValue"]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(messageErrorParticularPolicyModel.value), 1)
        ]),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label: "Par prix",
          name: "shippingRuleByPriceStatus",
          value: false,
          modelValue: shippingRuleByPriceStatus.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shippingRuleByPriceStatus).value = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(messageErrorStartingFromByPrice.value), 1)
        ]),
        (shippingRuleByPriceStatus.value)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              id: "repeater",
              name: "shipping_rules_by_price",
              type: "repeater",
              "add-label": "Ajouter",
              "up-control": false,
              "down-control": false,
              value: shippingRulesByType.value[1]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_FormKit, {
                        type: "number",
                        label: "A partir de ",
                        name: "startingFrom",
                        validation: "required",
                        min: "0",
                        step: "any",
                        "validation-visibility": "dirty",
                        "validation-messages": {required: 'Vous devez saisir une valeur',}
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_FormKit, {
                        type: "number",
                        label: "€ frais de port à ",
                        name: "price",
                        validation: "required",
                        "validation-label": "frais de port",
                        step: "any",
                        min: "0",
                        "validation-visibility": "dirty",
                        "validation-messages": {required: 'Vous devez saisir une valeur',}
                      })
                    ]),
                    _hoisted_13
                  ])
                ])
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label: "Par quantité",
          name: "shippingRuleByQuantityStatus",
          value: false,
          modelValue: shippingRuleByQuantityStatus.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((shippingRuleByQuantityStatus).value = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(messageErrorStartingFromByQuantity.value), 1)
        ]),
        (shippingRuleByQuantityStatus.value)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 1,
              id: "repeater",
              name: "shipping_rules_by_quantity",
              type: "repeater",
              "add-label": "Ajouter",
              "up-control": false,
              "down-control": false,
              value: shippingRulesByType.value[2]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_FormKit, {
                        type: "number",
                        label: "A partir de ",
                        name: "startingFrom",
                        validation: "required",
                        min: "1",
                        "validation-visibility": "dirty",
                        "validation-messages": {required: 'Vous devez saisir une valeur',}
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_FormKit, {
                        type: "number",
                        label: "produit(s) frais de port à ",
                        name: "price",
                        validation: "required",
                        "validation-label": "frais de port",
                        step: "any",
                        min: "0",
                        "validation-visibility": "dirty",
                        "validation-messages": {required: 'Vous devez saisir une valeur',}
                      })
                    ]),
                    _hoisted_20
                  ])
                ])
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label: "Par produit",
          name: "shippingRuleByProductStatus",
          value: false,
          modelValue: shippingRuleByProductStatus.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shippingRuleByProductStatus).value = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(messageErrorStartingFromByProduct.value), 1)
        ]),
        (shippingRuleByProductStatus.value)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 2,
              id: "repeater",
              name: "shipping_rules_by_product",
              type: "repeater",
              "add-label": "Ajouter",
              "up-control": false,
              "down-control": false,
              value: shippingRulesByType.value[3]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_FormKit, {
                        type: "number",
                        label: "A partir de ",
                        name: "startingFrom",
                        validation: "required",
                        min: "1",
                        "validation-visibility": "dirty",
                        "validation-messages": {required: 'Vous devez saisir une valeur',}
                      })
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_FormKit, {
                        type: "number",
                        label: "produit(s) frais de port à ",
                        name: "price",
                        validation: "required",
                        "validation-label": "frais de port",
                        step: "any",
                        min: "0",
                        "validation-visibility": "dirty",
                        "validation-messages": {required: 'Vous devez saisir une valeur',}
                      })
                    ]),
                    _hoisted_27
                  ])
                ])
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["form-class"])
  ], 64))
}
}

})